import PageHead from "@/components/PageHead";

export default function NotFound() {
    return (
        <>
            <PageHead title="Page not found | Samoony" noindex />
            <main
                data-testid="not-found"
                className="min-h-screen flex items-center justify-center bg-paper text-ink px-6"
            >
                <div className="max-w-md text-center space-y-4">
                    <h1 className="font-display text-3xl font-bold">
                        Page not found
                    </h1>
                    <p className="text-black/70">
                        That page is not here. Head back to the homepage.
                    </p>
                    <a
                        data-testid="not-found-home"
                        href="/"
                        className="samoony-pill samoony-pill-ghost inline-block"
                    >
                        Go to homepage
                    </a>
                </div>
            </main>
        </>
    );
}
